/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.contracts.rpc.ContractActionService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './ContractActionService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.contracts.rpc.ContractActionService#sendUpdatePaymentMethodEmail
 */
export const SEND_UPDATE_PAYMENT_METHOD_EMAIL_MUTATION_FIELD_NAME = 'com_hubspot_commerce_contracts_rpc_ContractActionService_sendUpdatePaymentMethodEmail';
export const SEND_UPDATE_PAYMENT_METHOD_EMAIL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SEND_UPDATE_PAYMENT_METHOD_EMAIL_MUTATION_FIELD_NAME,
  args: ['contractId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.sendUpdatePaymentMethodEmailRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.contracts.rpc.ContractActionService#terminateContract
 */
export const TERMINATE_CONTRACT_MUTATION_FIELD_NAME = 'com_hubspot_commerce_contracts_rpc_ContractActionService_terminateContract';
export const TERMINATE_CONTRACT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: TERMINATE_CONTRACT_MUTATION_FIELD_NAME,
  args: ['contractId', 'terminationDate'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.terminateContractRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.contracts.rpc.ContractActionService#cancelScheduledTermination
 */
export const CANCEL_SCHEDULED_TERMINATION_MUTATION_FIELD_NAME = 'com_hubspot_commerce_contracts_rpc_ContractActionService_cancelScheduledTermination';
export const CANCEL_SCHEDULED_TERMINATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CANCEL_SCHEDULED_TERMINATION_MUTATION_FIELD_NAME,
  args: ['contractId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.cancelScheduledTerminationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.contracts.rpc.ContractActionService#createRenewalQuote
 */
export const CREATE_RENEWAL_QUOTE_MUTATION_FIELD_NAME = 'com_hubspot_commerce_contracts_rpc_ContractActionService_createRenewalQuote';
export const CREATE_RENEWAL_QUOTE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_RENEWAL_QUOTE_MUTATION_FIELD_NAME,
  args: ['contractId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.createRenewalQuoteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.contracts.rpc.ContractActionService#createChangeQuote
 */
export const CREATE_CHANGE_QUOTE_MUTATION_FIELD_NAME = 'com_hubspot_commerce_contracts_rpc_ContractActionService_createChangeQuote';
export const CREATE_CHANGE_QUOTE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_CHANGE_QUOTE_MUTATION_FIELD_NAME,
  args: ['contractId', 'dealPipeline', 'dealStage', 'changeEffectiveDate'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.createChangeQuoteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.contracts.rpc.ContractActionService#getAllowedActions
 */
export const GET_ALLOWED_ACTIONS_QUERY_FIELD_NAME = 'com_hubspot_commerce_contracts_rpc_ContractActionService_getAllowedActions';
export const GET_ALLOWED_ACTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALLOWED_ACTIONS_QUERY_FIELD_NAME,
  args: ['contractId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getAllowedActionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});